import { Component, OnInit } from '@angular/core';
import { IrrNpvService } from './irr-npv.service';
import { environment } from 'src/environments/environment.prod';

@Component({
  selector: 'app-irr-npv',
  templateUrl: './irr-npv.component.html',
  styleUrls: ['./irr-npv.component.scss']
})
export class IrrNpvComponent implements OnInit {
  irrNpvData: any;
  loading: boolean = true;
  email: any;

  constructor(private IrrNpvService: IrrNpvService) { }

  ngOnInit(): void {
    this.email = localStorage.getItem("email");
    this.getIrrData();
  }

  getIrrData() {
    this.IrrNpvService.getIrrNpvLogData(this.email).subscribe((response) => {
      this.irrNpvData = response["data"];
      console.log("resss", this.irrNpvData);
      this.loading = false;

    });
  }

  redirectToOtherPage(brand_name, nda, dosage) {
    // window.open(`http://localhost:4200/#/settings?brand_name=${brand_name}&nda=${nda}&dosage=${dosage}`, '_blank');
    window.open(`${environment.ip}#/settings?brand_name=${brand_name}&nda=${nda}&dosage=${dosage}`, '_blank');
    // window.open(`http://3.111.249.237/#/settings?brand_name=${brand_name}&nda=${nda}&dosage=${dosage}`, '_blank');
  }

}